export const tabs = [
  {
    text: "Default",
    count: 0,
    key: "Default",
  },
  {
    text: "Completed",
    count: 0,
    key: "Completed",
  },
];

export const filterOption = [
  { name: "My Targets", value: "Assigned" },
  { name: "My Coaching Targets", value: "Coach" },
  { name: "My Team Targets", value: "All" },
];

export const reasonText = {
  WeightedTarget: "Weighted target",
  UserRoleChange: "User role change",
  UserDepartmentChange: "User department change",
};

export const targetSelectionMessages = [
  {
    key: "createStory",
    emptyCount: `Select targets from the below table which you'd like to discuss
    in your success story`,
  },
  {
    key: "createPerformanceReview",
    emptyCount: `Select targets from the below table which you'd like to discuss
    in your performance review`,
  },
  {
    key: "archiveTarget",
    type: "Delete",
    emptyCount: "Select targets to Archive",
    actionButton: "Archive Targets",
    toast: "Target archived successfully",
    title: "Archive targets",
    body: "Are you sure you want to archive targets permanently?",
  },
  {
    key: "deleteTarget",
    type: "Delete",
    emptyCount: "Select targets to Delete",
    actionButton: "Delete Targets",
    toast: "Target deleted successfully",
    title: "Delete targets",
    body: "Are you sure you want to delete targets permanently?",
  },
  {
    key: "restoreTarget",
    type: "Restore",
    emptyCount: "Select targets to restore",
    actionButton: "Restore Targets",
    toast: "Target restored successfully",
    title: "Restore targets",
    body: "Are you sure you want to restore targets?",
  },
];

export const targetStatusColor = {
  Hold: "#D1F8F2",
  Draft: "#DAD8D8",
  Paused: "#DDDBDB",
  Active: "#DAECFF",
  "Pre-meeting": "#DAECFF",
  "In progress": "#DAECFF",
  Overdue: "#FFE6E6",
  Completed: "#D5F9E3",
  Complete: "#D5F9E3",
  Closed: "#D5F9E3",
  Planned: "#D1F8F2",
  Incomplete: "#FFF2CF",
  Archived: "#F1DEFE",
  Pending: "#FFE8D6",
  Pendingapproval: "#FFE8D6",
  Deactivated: "#DDDBDB",
  Reactivated: "#F1DEFE",
  Rejected: "#DAD8D8",
  Acknowledged: "#F1DEFE",
  "Pending reviewer": "#DAECFF",
  "Pending employee": "#FFE8D6",
  "Pending meeting": "#F1DEFE",
};

export const targetProgressBarColor = {
  Hold: "#D1F8F2",
  Active: "#519CE8",
  Overdue: "#EF7713",
  Completed: "#15C473",
  Closed: "#15C473",
  Pending: "#BC501C",
  InProgress: "#EF7713",
};

export const targetStatusTxtColor = {
  Hold: "#138D7D",
  Draft: "#202F43",
  Paused: "#202F43",
  Active: "#07519C",
  "Pre-meeting": "#07519C",
  "In progress": "#07519C",
  Overdue: "#C41313",
  Completed: "#0A652B",
  Complete: "#0A652B",
  Closed: "#0A652B",
  Planned: "#138D7D",
  Incomplete: "#C27B1E",
  Archived: "#8826A0",
  Pending: "#BC501C",
  Pendingapproval: "#BC501C",
  Deactivated: "#202F43",
  Reactivated: "#8826A0",
  Rejected: "#202F43",
  Acknowledged: "#8826A0",
  "Pending reviewer": "#07519C",
  "Pending employee": "#BC501C",
  "Pending meeting": "#8826A0",
};

export const targetStatusColorDark = {
  Active: "#3481D2",
  Pending: "#ED7020",
  Closed: "#00B389",
  Overdue: "#FE4343",
  Paused: "#7B7D82",
  Draft: "#5E6066",
  Incomplete: "#C27B1E",
  Hold: "#189194",
  Planned: "#2E9B9E",
  "Pre-meeting": "#07519C",
  "In progress": "#07519C",
  Pendingapproval: "#BC501C",
  Deactivated: "#202F43",
  Reactivated: "#8826A0",
  Rejected: "#202F43",
  Acknowledged: "#8826A0",
  Archived: "#8826A0",
  "Pending reviewer": "#07519C",
  "Pending employee": "#ED7020",
  "Pending meeting": "#8826A0",
};

export const targetStatusColorOpacity = {
  Active: "rgb(52 129 210 / 70%)",
  Closed: "rgb(0 179 137 / 70%)",
  Incomplete: "rgb(194 123 30 / 70%)",
  Paused: "rgb(123 125 130 / 70%)",
  Pending: "rgb(237 112 32 / 70%)",
  Planned: "rgb(46 155 158 / 70%)",
  Overdue: "rgb(254 67 67 / 70%)",
  Draft: "rgb(94 96 102 / 70%)",
  Hold: "rgb(24 145 148 / 70%)",
  Archived: "rgb(136 38 160 / 70%)",
};

// needshelp: {
//   "& .MuiOutlinedInput-root": {
//     background: "#F1DEFE",
//     color: "#8826A0"
//   }
// }
export const successStoryFormType = (type) => {
  return type === "assigned" ? "Assigned" : "All";
};
